//----------------------------
// save current editable rune
//----------------------------
export default function saveCurrentEditableRune(rune) {
  const integratedCharacter =
    typeof rune.integrated_character === 'object'
      ? (rune.integrated_character?.id ?? null)
      : (rune.integrated_character ?? rune.integrated_character_id ?? null)
  // --------------
  // define object
  // --------------
  let original_rune = {
    strength: rune.strength ?? 0,
    pwr_storage: rune.pwr_storage ?? 0,
    starter: rune.starter ?? false,
    already_integrated: rune.already_integrated ?? false,
    integrated: rune.integrated ?? false,
    integrated_character: integratedCharacter,
    character_item: rune.character_item ?? null,
    notes: rune.notes ?? '',
  }
  return original_rune
}
